import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { BRAND } from "@/lib/brand";
import { resolveImageUrl } from "@/lib/api";

export default function Gallery() {
  const { t } = useI18n();
  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl mb-14"
        >
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-4 font-medium">{t.gallery.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] uppercase leading-[1.05]">{t.gallery.title}</h2>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-testid="gallery-grid">
          {BRAND.galleryPhotos.map((url, idx) => (
            <motion.div
              key={url}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: (idx % 6) * 0.07 }}
              className="overflow-hidden rounded-2xl bg-[#eae0df] group relative aspect-square shadow-[0_8px_30px_rgb(28,36,33,0.04)] hover:shadow-[0_24px_45px_rgb(28,36,33,0.12)] transition-shadow"
              data-testid={`gallery-item-${idx}`}
            >
              <img
                src={resolveImageUrl(url)}
                alt={`Aura ${idx + 1}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110"
              />
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="mt-14 text-center"
        >
          <a
            href="#disponibilidad"
            data-testid="gallery-cta-calendar"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#3e664c] hover:bg-[#2e5949] text-[#fdfcf9] text-sm uppercase tracking-[0.18em] transition-colors"
          >
            {t.cta.yourDate}
          </a>
        </motion.div>
      </div>
    </section>
  );
}
